<div class="login-container">
  <!-- Left Panel -->
  <div class="left-panel">

    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png">
      <img src="assets/dashboard icons/logo2.png">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png">
      <img src="assets/dashboard icons/logo4.png">
      <img src="assets/dashboard icons/logo5.png">
    </div>

    <!-- <div class="left-panel-text">
      Accredited Social Health Activists
    </div> -->
    <div class="left-panel-text">
      {{ isMr
      ? 'मान्यताप्राप्त सामाजिक आरोग्य कार्यकर्त्या'
      : 'Accredited Social Health Activists' }}
    </div>
    <img src="assets/dashboard icons/AshaPic.png" alt="Asha" />
  </div>

  <div class="right-container">
    <div class="login-card">
      <!-- Desktop logo -->
      <img src="assets/icons/headericon_pink.png" alt="Asha" />
      <!-- <h2 class="login-title">OTP Verification</h2> -->
      <h2 class="login-title">
        {{ isMr ? 'ओटीपी पडताळणी' : 'OTP Verification' }}
      </h2>

      <!-- Mobile replacement image -->
      <img src="assets/loginImg.png" alt="Asha" class="mobile-login-image" />
      <!-- <p class="login-subtitle" style="line-height: 1.7;"> A 6-digit OTP has been sent to  <b>{{formData.EmailID}}</b>.<br>
       Please enter the code below to continue</p> -->

      <p class="login-subtitle" style="line-height: 1.7;">
        {{ isMr
        ? '६ अंकी ओटीपी '
        : 'A 6-digit OTP has been sent to ' }}
        <b>{{ formData.EmailID }}</b>
        <br>
        {{ isMr
        ? 'वर पाठवण्यात आला आहे. पुढे जाण्यासाठी खाली कोड टाका'
        : 'Please enter the code below to continue' }}
      </p>

      <form class="login-form" (submit)="verifyotp()">

        <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top" class="custom-login-form"
          [showColonAfterLabel]="false">

          <dxi-form-item dataField="OTP" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
              placeholder: isMr ? 'ओटीपी टाका' : 'Enter OTP',
              buttons: [{
                name: 'userIcon',
                id: 'OTP',
                 value: formData.OTP,
                location: 'after',
                options: { icon: 'custom-user-icon' }
              }]
            }">
            <!-- <dxo-label text="Username"></dxo-label> -->
          </dxi-form-item>
        </dx-form>

        <div style="text-align: center; margin-top: 2px;">
          <!-- <p> Didn't receive code..?</p> -->
          <p>
            {{ isMr ? 'कोड मिळाला नाही?' : "Didn't receive the code?" }}
          </p>
        </div>
        <div class="forgot-password-text" style="margin-top: 2px;">
          <!-- <p> Resend in {{ isResendOtpDisabled ? '' + ResendOtpTimer + 'sec' : '' }}</p> -->
          <p>
            {{ isMr ? 'पुन्हा पाठवा ' : 'Resend in ' }}
            {{ isResendOtpDisabled ? ResendOtpTimer + (isMr ? ' सेकंद' : ' sec') : '' }}
          </p>
          <!-- <a  (click)="ResendOtp()"  [style.cursor]="isResendOtpDisabled ? 'not-allowed' : 'pointer'">Resend Code</a> -->
          <a (click)="ResendOtp()" [style.cursor]="isResendOtpDisabled ? 'not-allowed' : 'pointer'">
            {{ isMr ? 'पुन्हा पाठवा' : 'Resend Code' }}
          </a>
        </div>
        <dx-button [text]="isMr ? 'ओटीपी सबमिट करा' : 'Submit OTP'" type="default" stylingMode="contained" class="login-button"
          (click)="verifyotp()"></dx-button>
      </form>
    </div>
  </div>
</div>